import React from 'react';
import { Card, CardContent } from '@mui/material';
import QuestionTitleBar from './QuestionTitleBar';
import QuestionDisplay from './QuestionDisplay';
import AnswerSection from './AnswerSection';
import NavigationControls from './NavigationControls';

interface Question {
  id: number;
  text: string;
  options: string[];
  correctAnswer: number;
  userAnswer?: number;
  isMarkedForReview?: boolean;
  mediaUrl?: string; // Add mediaUrl support
}

interface QuestionCardProps {
  currentQuestion: Question;
  currentQuestionIndex: number;
  totalQuestions: number;
  timeRemaining: number;
  testColor: string;
  lightenColor: (color: string, amount: number) => string;
  onAnswerSelect: (answerIndex: number) => void;
  onPrevious: () => void;
  onNext: () => void;
  onMarkForReview: () => void;
  seriesName?: string;
  grade?: string;
  subject?: string;
}

const QuestionCard: React.FC<QuestionCardProps> = ({
  currentQuestion,
  currentQuestionIndex,
  totalQuestions,
  timeRemaining,
  testColor,
  lightenColor,
  onAnswerSelect,
  onPrevious,
  onNext,
  onMarkForReview,
  seriesName,
  grade,
  subject
}) => {
  return (
    <Card sx={{ 
      borderRadius: 3,
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
      transition: 'all 0.2s ease-in-out',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      '&:hover': {
        boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.1)'
      }
    }}>
      <QuestionTitleBar
        currentQuestionIndex={currentQuestionIndex}
        totalQuestions={totalQuestions}
        timeRemaining={timeRemaining}
        testColor={testColor}
        lightenColor={lightenColor}
        seriesName={seriesName}
        grade={grade}
        subject={subject}
      />
      
      <CardContent sx={{ 
        p: 4, 
        flexGrow: 1, 
        display: 'flex', 
        flexDirection: 'column' 
      }}>
        <QuestionDisplay
          question={currentQuestion}
          questionNumber={currentQuestionIndex + 1}
          totalQuestions={totalQuestions}
        />
        
        <AnswerSection
          question={currentQuestion}
          onAnswerSelect={onAnswerSelect}
        />
        
        <div style={{ marginTop: 'auto' }}>
          <NavigationControls
            currentQuestionIndex={currentQuestionIndex}
            totalQuestions={totalQuestions}
            isMarkedForReview={currentQuestion?.isMarkedForReview || false}
            onPrevious={onPrevious}
            onNext={onNext}
            onMarkForReview={onMarkForReview}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default QuestionCard;